const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarlyPaymentAllowed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.355605, 0, 0, 1.355605, -123.863785, -31.89089)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "m327.6 204.4c0 13.918-11.285 25.203-25.203 25.203-13.914 0-25.199-11.285-25.199-25.203 0-13.914 11.285-25.199 25.199-25.199 13.918 0 25.203 11.285 25.203 25.199",
    style: {
      fill: "rgb(140, 50, 214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.8 350c0 13.918-11.285 25.199-25.199 25.199-13.918 0-25.203-11.281-25.203-25.199s11.285-25.199 25.203-25.199c13.914 0 25.199 11.281 25.199 25.199",
    style: {
      fill: "rgb(140, 50, 214)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588 338.24-28.559-58.238 28.559-58.238c6.1602-12.879 1.1211-28-11.199-34.719l-57.121-30.242-11.199-63.84c-2.2383-14-15.68-23.52-29.68-21.281l-64.398 8.9609-46.48-44.801c-10.078-10.078-26.32-10.078-36.398 0l-46.48 44.801-63.844-9.5195c-14-2.2383-26.879 7.2812-29.68 21.281l-11.199 63.84-57.121 30.797c-12.32 6.7188-17.359 21.84-11.199 34.719l28.559 58.242-28.559 58.238c-6.1602 12.879-1.1211 28 11.199 34.719l57.121 30.242 11.199 63.84c2.2383 14 15.68 23.52 29.68 21.281l64.398-8.9609 46.48 45.359c10.078 10.078 26.32 10.078 36.398 0l46.48-45.359 63.844 9.5195c14 2.2383 26.879-7.2812 29.68-21.281l11.199-63.84 57.121-30.238c12.32-7.2812 17.359-22.398 11.199-35.281zm-333.2-133.84c0-26.32 21.281-47.602 47.602-47.602 26.32 0 47.602 21.281 47.602 47.602-0.003906 26.32-21.285 47.602-47.605 47.602-26.32 0-47.598-21.281-47.598-47.602zm34.16 171.92c-2.2383 2.8008-5.6016 4.4805-8.9609 4.4805-2.2383 0-4.4805-0.55859-6.7188-2.2383-5.0391-3.9219-5.6016-10.641-2.2383-15.68l145.04-190.4c3.9219-5.0391 10.641-5.6016 15.68-2.2383 5.0391 3.9219 5.6016 10.641 2.2383 15.68zm108.64 21.281c-26.32 0-47.602-21.281-47.602-47.602s21.281-47.602 47.602-47.602c26.32 0 47.602 21.281 47.602 47.602-0.003906 26.32-21.281 47.602-47.602 47.602z",
    style: {
      fill: "rgb(140, 50, 214)"
    }
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 70, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 90.55078125, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 104.359375, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 123.34765625, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 142.2421875, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 155.62890625, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 174.6171875, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 204.41015625, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 224.453125, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 252.453125, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 280.3125, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 299.55078125, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 319.484375, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 332.8671875, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 362.55078125, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 382.828125, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 401.71875, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 421.765625, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 440.65625, 644)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 70, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 82.18359375, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 95.9921875, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 115.2265625, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 154.15234375, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 167.53515625, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 187.46875, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 216.20703125, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 239.640625, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 258.87890625, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 278.8125, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 308.4921875, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 329.015625, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 342.8203125, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 362.05859375, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 371.65625, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 390.6484375, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1, 0, 0, 1, 407.2421875, 672)",
    style: {
      fill: "rgb(140, 50, 214)"
    },
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyPaymentAllowed);
export default __webpack_public_path__ + "static/media/early-payment-allowed.66ef0037.svg";
export { ForwardRef as ReactComponent };